export default {
  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  },

  inhabitantChanges: (state, inhabitant_changes) => {
    state.inhabitantChanges = inhabitant_changes;
  },

  setInhabitantChangeStatuses: (state, statuses) => {
    state.inhabitantChangeStatuses = statuses;
  },

  setInhabitantChangeSources: (state, sources) => {
    state.inhabitantChangeSources = sources;
  },

  setInhabitantChangeTypes: (state, types) => {
    state.inhabitantChangeTypes = types;
  }
};
